<template>
	<div class="info" v-if="selected">
		<!-- <div>
			Key: {{ selected.key }}<br>
			Name: {{ selected.name }}<br>
			Category: {{ selected.category }}<br>
			Application: {{ selected.application }}<br>
			In the Dish: {{ selected.inTheDish }}<br>
		</div> -->
		<div :class="{ 'info__details-block': true, 'animate': change }" v-if="selected.Title">
			<div @animationend="animationOver">
				<h1>{{ selected.Title }}</h1>
				<p 
				v-if="selected.Winner"
				class="winner"
				>
					To-Go Winner
				</p>
				<p v-if="selected.UnJIFingBelieveableWinner" class="winner">
					UnJifingBelieveable Winner
				</p>
				<p v-if="selected.TravelsWell" class="winner">
					Travels Well
				</p>
				<p v-html="selected.Description" />
				<a
					v-if="selected.RelatedRecipe"
					:href="selected.RelatedRecipe"
					class="button"
					target="_blank"
					data-gtmcat="Jif Tool"
					data-gtmaction="click"
					:data-gtmlabel="'See Full Recipe | ' + clean(selected.Title)"
				>
					{{ selected.RecipeButtonText }}
				</a>
				
			</div>
			<div>
				<img :src="selected.PreparedImageDetail" alt="">
			</div>
		</div>
		<div :class="{ 'info__other-products-block': true, 'animate': change }" v-if="selected.RelatedProducts">
			
			<div @animationend="animationOver" class="info__on-the-side" v-if="selected.RecipeType === 'on-the-side' && selected.RelatedProducts">
				<h2>On the Side:</h2>
				<ul>
					<li v-for="(rp, index) in selected.RelatedProducts" :key="index">
						<a
							:href="rp.Link"
							target="_blank"
							v-if="rp.Link"
							data-gtmcat="Jif Tool"
							data-gtmaction="click"
							:data-gtmlabel="'On the Side | ' + clean(rp.Title)"
						>
							<img :src="rp.Image" alt="">
							<div v-if="rp.Title" v-html="rp.Title" />
						</a>
						<div v-else>
							<img :src="rp.Image" alt="">
							<div v-if="rp.Title" v-html="rp.Title" />
						</div>
					</li>
				</ul>
			</div>
		
		
			<div class="info__made-with" v-if="selected.RecipeType === 'in-the-dish' && selected.RelatedProducts">
				<h2>Made With:</h2>
				<ul>
					<li v-for="(rpr, rindex) in selected.RelatedProducts" :key="rindex">
						<a
							:href="rpr.Link"
							target="_blank"
							v-if="rpr.Link && rpr.Title"
							data-gtmcat="Jif Tool"
							data-gtmaction="click"
							:data-gtmlabel="'Made With | ' + clean(rpr.Title)"
						>
							<img :src="rpr.Image" alt="">
							<div v-if="rpr.Title" v-html="rpr.Title" />
						</a>
						<div v-else>
							<img :src="rpr.Image" alt="">
							<div v-if="rpr.Title" v-html="rpr.Title" />
						</div>
					</li>
				</ul>
				<a
					v-if="includesJifAndNoFlavorHack"
					href="https://www.smuckerawayfromhome.com/products/Jif-Products" 
					class="button"
					target="_blank"
					data-gtmcat="Jif Tool"
					data-gtmaction="click"
					data-gtmlabel="Shop Jif"
				>
					Shop Jif
				</a>
			</div>
		

			<div class="info__flavor-hack" v-if="selected.FlavorHack">
				<template v-if="selected.FlavorHack.length > 0">
					<h2 v-if="selected.SmoothSwap">Smooth Swap:</h2>
					<h2 v-else>Flavor Hack:</h2>
					<ul>
						<li v-for="(fh, findex) in selected.FlavorHack" :key="findex">
							<a
								:href="fh.Link"
								target="_blank"
								v-if="fh.Link"
								data-gtmcat="Jif Tool"
								data-gtmaction="click"
								:data-gtmlabel="'Flavor Hack | ' + clean(fh.Title)"
							>
								<img :src="fh.Image" alt="">
								<div v-html="fh.Title" />
							</a>
							<div v-else>
								<img :src="fh.Image" alt="">
								<div v-html="fh.Title" />
							</div> 
						</li>
					</ul>
				</template>
			</div>

		</div>

		<div @animationend="animationOver" :class="{ 'info__also-block': true, 'animate': change }" v-if="selected.ConsiderStat">

			<div class="info__consider" v-if="selected.ConsiderStat">
				<h2>Consider:</h2>
				<p v-html="selected.ConsiderStat" />
			</div>

			<div class="info__promote" v-if="selected.RecipeType === 'in-the-dish'">
				<div>
					<img
						src="https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/peanut-butter-spoon@2x.png"
						alt="a spoonful of peanut butter"
					>
				</div>
				<div>
					<h2>Promote: </h2>
					<p v-html="selected.UpchargeDescription" />
					<a
						href="/brands/jif"
						class="button"
						target="_blank"
						data-gtmcat="Jif Tool"
						data-gtmaction="click"
						data-gtmlabel="Get Jif Support | Promote"
					>
						Get Jif Support
					</a>
				</div>
				<div v-if="selected.UpchargeSource" class="fine-print">
					<div v-html="selected.UpchargeSource" />
				</div>
			</div>

			<div class="info__upcharge" v-if="selected.RecipeType === 'on-the-side'">
				<div>
					<img src="https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/jif-merch-markup@2x.png" alt="An image of various Jif related collateral including a table tent">
				</div>
				<div>
					<h2>Promote: <span>{{selected.UpchargeAmount}}</span></h2>
					<p v-html="selected.UpchargeDescription" />
					<a
						href="/brands/jif"
						class="button"
						target="_blank"
						data-gtmcat="Jif Tool"
						data-gtmaction="click"
						data-gtmlabel="Get Jif Support | Upcharge"
					>
						Get Jif Support
					</a>
				</div>
				<div v-if="selected.UpchargeSource" class="fine-print">
					<div v-html="selected.UpchargeSource" />
				</div>
			</div>

		</div>
		<div class="info__mobile-footer">
			<MobileFooter />
		</div>
	</div>
</template>

<script>
import MobileFooter from './MobileFooter'

export default {
	name: 'Info',
	components: {
		MobileFooter,
	},
	props: {
		selected: {
			type: Object,
			default: () => {}
		},
		change: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		includesJifAndNoFlavorHack() {
			if (this.selected) {
				if (this.selected.FlavorHack.length > 0) {
					return false
				} else {
					return this.selected.RelatedProducts.filter((product) => {
						return product.Title.includes('Jif');
					})
				}
			} else {
				return false;
			}
		}
	},
	methods: {
		animationOver() {
			this.$emit('animationOver')
		},
		clean(str) {
			let regex = /(<([^>]+)>)/ig;
			return str.replace(regex, "")
		}
	},
}
</script>

<style lang="scss">
@import "../styles/_colors.scss";
@import "../styles/_variables.scss";
@import "../styles/_mixins.scss";
@import "../styles/vendor/_index.scss";

$productDetailClip: polygon(0 10%, 100% 0, 100% 100%, 0 90%);
$productClip: polygon(8% 0, 92% 0, 100% 24%, 100% 100%, 0 100%, 0 24%);
$detailsClip: polygon(50% 0%, 100% 0, 100% 100%, 0 100%, 0 8%);
$alsoClip: polygon(100% 0, 100% 100%, 50% 100%, 0 92%, 0 0);

.info {
	// grid-template-rows: repeat(11, 80px);
	margin-top: -1.25em;
	h1, h2, p {
		color: white;
		// hyphens: auto;
	}
	& > div {
		grid-column: 1;
		position: relative;
		z-index: map-get($z, 1);
		&:nth-child(1) {
			z-index: map-get($z, 2);
		}
		&.animate {
			animation: scale-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
			&:nth-child(2) {
				animation-delay: 100ms;
			}
			&:nth-child(3) {
				animation-delay: 200ms;
			}
			& > div {
				animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
				animation-delay: 500ms;
			}
		}
	}
	@include breakpoint(large) {
		display: grid;
		grid-template-columns: 1fr;
		margin-top: 0;
		margin-left: -2.5em;
		grid-template-rows: repeat(12, 1fr);
		height: 100vh;
		min-height: $minHeight;
		& > div {
			padding-left: 2.5em;
			&.animate {
				animation: scale-in-hor-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
			}
		}
	}
	@include breakpoint(xlarge) {
		& > div {
			padding-left: 3em;
		}
	}
}
.info__other-products-block {
	background-color: $blue;
	padding: 1.25em;
	// grid-row: 3 / 6;
	@include breakpoint(large) {
		grid-row: 1 / 5;
		padding-top: 1.5em;
		clip-path: $detailsClip;
	}
	@include breakpoint(xlarge) {
		padding-top: 2em;
	}
}

.info__on-the-side {
	max-width: 400px;
	margin: 0 auto;
	h2 {
		text-align: center;
	}
	ul {
		display: grid;
		grid-gap: 1em;
		grid-template-columns: 1fr 1fr;
		margin-bottom: 0.333em;
		li {
			a {
				text-decoration: underline;
				color: white;
			}
			a, & > div {
				display: flex;
				align-items: center;
			}
			img {
				// max-width: 66px;
				width: auto;
				max-height: 66px;
				height: auto;
			}
			p {
				padding-left: 1em;
				color: white;
			}
		}
	}
	@include breakpoint(large) {
		margin: 0;
		max-width: 100%;
		h2 {
			text-align: left;
		}
	}
}

.info__flavor-hack {
	max-width: 330px;
	margin: 1.5em auto;
	display: flex;
	align-items: center;
	h2 {
		flex: 1 1 48%;
		padding-right: 0.5em;
		margin-bottom: 0;
	}
	img {
		max-width: 44px;
		height: auto;
	}
	ul > li > a, ul > li > div {
		display: flex;
		align-items: center;
		color: white;
		p {
			margin-bottom: 0;
			margin-left: 1em;
			color: white;
		}
	}
	ul > li > a {
		text-decoration: underline;
	}
	@include breakpoint(large) {
		margin: 0;
		max-width: 100%;
		justify-content: flex-start;
		h2 {
			flex: 0 0 auto;
		}
	}
}

.info__made-with {
	max-width: 400px;
	margin: 1.5em auto 0 auto;
	text-align: center;
	img {
		// max-width: 66px;
		width: auto;
		max-height: 66px;
	}
	ul > li {
		margin: 0 auto 1.5em auto;
		width: 50%;
		// a {
		// 	&:hover {
		// 		text-decoration: underline;
		// 		color: white;
		// 	}
		// }
		a:first-child, div:first-child {
			display: flex;
			align-items: center;
			margin-bottom: 0.75em;
			p {
				margin-left: 1em;
				text-align: left;
			}
		}
		a:first-of-type {
			text-decoration: underline;
			color: white;
		}
		a.button {
			text-decoration: none;
		}
	}
	@include breakpoint(large) {
		margin: 0;
		max-width: 100%;
		text-align: left;
		ul {
			display: flex;
			& > li {
				flex: 0 0 50%;
				margin: 0;
				&:first-child {
					padding-right: 0.5em;
				}
				&:last-child {
					padding-left: 0.5em;
				}
				& > div {
					width: 100%;
					margin: 0 0 1em 0;
				}
			}
		}
	}
}
.info__details-block {
	background-color: $red;
	padding: 2.5em 1.25em 1.5em 1.25em;
	// grid-row: 1 / 3;
	clip-path: $productClip;
	text-align: center;
	.button {
		background-color: $dred;
	}
	.winner {
		color: $yellow;
		font-size: 1.5em;
		line-height: 1;
		text-align: center;
		text-transform: uppercase;
		font-family: $sans;
		font-weight: 700;
		margin: 0 0 .25em 0;
		@include breakpoint(large) {
			text-align: left;
		}
	}
	h1 {
		margin-bottom: .1em;
	}
	p {
		margin: 0 auto 1em auto;
		position: relative;
		z-index: map-get($z, 1);
	}
	img {
		display: none;
	}
	@include breakpoint(large) {
		text-align: left;
		grid-row: 4 / 9;
		clip-path: $productDetailClip;
		// padding-right: 30%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		padding: 1.5em 0 1.5em 1.25em;
		& > div:first-child {
			flex: 0 0 60%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-start;
		}
		& > div:last-child {
			// margin-right: -50%;
			flex: 0 0 25%;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			img {
				display: block;
				position: absolute;
				width: 560px;
				top: calc(50% - 250px);
				bottom: 0;
				right: -300px;
			}
		}
	}
}
.info__also-block {
	background-color: $green;
	padding: 1.25em;
	overflow: hidden;
	// grid-row: 6 / 10;
	.button {
		background-color: $dgreen;
	}
	@include breakpoint(large) {
		grid-row: 8 / 13;
		clip-path: $alsoClip;
		padding-top: 6em;
		display: grid;
		grid-template-columns: 1fr 2fr;
		grid-template-rows: 1fr 1fr;
	}
	// @include breakpoint(xxlarge) {
	// 	padding-top: 8vh;
	// }
}

.info__consider {
	max-width: 400px;
	margin: 0 auto;
}

.info__upcharge {
	max-width: 400px;
	margin: 0 auto;
	display: grid;
	grid-template-columns: 1.5fr 3fr;
	div:first-child {
		// flex: 0 0 33.333%;
		span {
			color: white;
		}
	}
	div:nth-child(2) {
		margin-left: 1em;
	}
	div:nth-child(3) {
		grid-column: 2 / 3;
	}
}

.info__promote {
	max-width: 400px;
	margin: 0 auto -1.25em auto;
	display: grid;
	grid-template-columns: 1.5fr 3fr;
	position: relative;
	div:first-child {
		// flex: 0 0 40%;
		img {
			position: absolute;
			width: 120px;
			// left: -0.5em;
			top: 0;
		}
		span {
			color: white;
		}
	}
	div:nth-child(2) {
		margin-left: 1em;
		// margin-bottom: 1em;
	}
	div:nth-child(3) {
		grid-column: 2 / 3;
	}
	@include breakpoint(large) {
		div:first-child {
			img {
				left: 0;
				position: absolute;
				// top: -10px;
				bottom: -160px;
				z-index: map-get($z, 3);
			}
		}
	}
}

.info__mobile-footer {
	grid-row: 10 / 11;
	@include breakpoint(large) {
		display: none;
	}
}

.fine-print {
	font-family: $slab;
	font-size: em(8);
	color: white;
	margin-top: 2em;
	.info__promote + & {
		// position: absolute;
		right: 2em;
		bottom: 2em;
	}
	& > div {
		position: relative;
		z-index: map-get($z, 3);
		// color: darken($green, 12%);
		// text-shadow: 1px 1px rgba($text, 0.7);
	}
	@include breakpoint(xmedium down) {
		// padding-left: 46%;
		padding-left: 1.5em;
		margin-bottom: 2em;
	}
	@include breakpoint(large) {
		grid-row: 2 / 3;
		grid-column: 2 / 3;
		text-align: right;
		.info__promote + & {
			bottom: 0;
		}
	}
}

/* ----------------------------------------------
 * Generated by Animista on 2020-10-28 11:43:29
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-in-hor-left
 * ----------------------------------------
 */
@keyframes scale-in-hor-left {
  0% {
    transform: scaleX(0);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation scale-in-top
 * ----------------------------------------
 */
@keyframes scale-in-top {
  0% {
    transform: scale(0);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 0%;
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation fade-in
 * ----------------------------------------
 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}



</style>